<template>
    <div style="padding: 20px; box-shadow: 3px 3px 10px #aaa; " class="panel">
        <div class="panel-title" style="background-color: #6a6;">
            <h2 style="padding: 10px; margin:0; color: #fff;">Completed Tasks</h2>
        </div>
        <div class="panel-body">
            <div v-if="loading" align="center">
                <i class="fa fa-spinner fa-spin fa-4x"></i>
            </div>
            <div v-show="!loading">
                <span v-if="completedTasks.length === 0"> - none - </span>
                <div v-show="completedTasks.length > 0">
                    <table class="table no-margins" id="completed-tasks-table">
                        <thead>
                        <tr>
                            <th>Code</th>
                            <th>Lesson</th>
                            <th>Task</th>
                            <th>Locale</th>
                            <th>Started</th>
                            <th>Completed</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="task in completedTasks">
                            <td>{{task.lessonCode}}</td>
                            <td>{{task.lessonTitle}}</td>
                            <td>{{task.actionTitle}}</td>
                            <td>{{task.language + ', ' + task.country}}</td>
                            <td :data-sort="task.startedAt ? convertToDateTime(task.startedAt) : ''">
                        <span style="white-space: nowrap"
                              :title="task.startedAt ? convertToDateTime(task.startedAt) : 'unknown'">
                            {{convertToHumanReadable(task.startedAt)}}
                        </span>
                            </td>
                            <td :data-sort="task.completedAt ? convertToDateTime(task.completedAt) : ''">
                        <span style="white-space: nowrap"
                              :title="task.completedAt ? convertToDateTime(task.completedAt) : 'unknown'">
                            {{convertToHumanReadable(task.completedAt)}}
                        </span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    let moment = require('moment');
    require('../../../vendor/jquery/plugins/dataTables/datatables.min');

    export default {
        props: [
            'userId',
        ],

        data() {
            return {
                loading: true,
                completedTasks: [],
                tableRendered: false,
            };
        },

        mounted: function() {
            this.fetchCompletedTasks(true);
        },

        updated: function() {
            this.$nextTick(function() {
                this.renderDataTable();
            });
        },

        computed: {},

        methods: {
            convertToDateTime: (atomString) => moment(atomString).local().format('YYYY-MM-DD HH:mm:ss'),
            convertToHumanReadable: (atomString) => moment(atomString).local().fromNow(),

            renderDataTable: function() {
                const tableNode = $('#completed-tasks-table');

                tableNode.DataTable().destroy();

                if (!this.loading && this.completedTasks.length > 0) {
                    tableNode.DataTable({
                        pageLength: 10,
                        responsive: true,
                        dom: 'ftp',
                        bInfo: false,
                        stateSave: false,
                        stateDuration: 0,
                    });
                }
            },

            fetchCompletedTasks: function(all) {
                this.loading = true;
                const appendix = all ? '?nolimit=1' : '';
                fetch('/user/' + this.userId + '/completedTasks' + appendix)
                .then(response => response.json())
                .then(data => {
                    this.completedTasks = data.completedTasks;
                    this.loading = false;
                })
                .catch((error) => {
                    console.error('Error:', error);
                    alert('An error occurred trying to fetch your running tasks. '
                        + 'Please take a screenshot and report the error!\n\n' + error);
                });
            },
        },
    };
</script>
